import React from'react';import PropTypes from'prop-types';import {useIntl}from'react-intl';import styled from'styled-components';import {useLocation,Link}from'react-router-dom';import {useTheme,useNavigation,useMedia,BREAKPOINTS,SideNav as SideNav$2,MainNavItem,Icon,SubNavItem,Lang}from'@manulife/mux';import useRealm from'../../hooks/useRealm.js';import usePathBuilder from'../../hooks/usePathBuilder.js';import ContactUs from'./MenuItems/ContactUs.js';import {getFilteredRealms,HEADER_REALM_KEYS}from'../../utils/realmUtils.js';import FormattedRichMessage from'../FormattedRichMessage/FormattedRichMessage.js';var RealmWrapper = /*#__PURE__*/styled.ul.withConfig({
  displayName: "SideNav__RealmWrapper",
  componentId: "sc-9x4omd-0"
})(["display:flex;flex-direction:row;list-style:none;width:100%;margin:0;padding:0;background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_2;
});
var RealmNavItemWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "SideNav__RealmNavItemWrapper",
  componentId: "sc-9x4omd-1"
})(["&& > li{margin:0 16px;border:none;}&& > li > a{height:50px;padding:0;background-color:", ";border:0 solid ", ";border-width:", ";font-weight:", ";&:hover{", "}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_2;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.primaryColors.main.shade_default;
}, function (_ref4) {
  var selected = _ref4.selected;
  return selected ? '0 0 4px' : '0';
}, function (_ref5) {
  var selected = _ref5.selected;
  return selected ? '600' : 'inherit';
}, function (_ref6) {
  var selected = _ref6.selected,
    theme = _ref6.theme;
  return !selected ? "\n        text-shadow: 0px 0px 0px ".concat(theme.colorPalette.neutralColors.light.shade_white, ",\n        0px 0px 0px ").concat(theme.colorPalette.neutralColors.light.shade_white, "\n      ") : '';
});
var SideNav = function SideNav(props) {
  var onLanguageToggle = props.onLanguageToggle,
    onLogout = props.onLogout,
    absoluteCiamDomain = props.absoluteCiamDomain,
    showLangToggle = props.showLangToggle,
    showRealmToggle = props.showRealmToggle,
    showContactUs = props.showContactUs,
    showManageId = props.showManageId;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var pathBuilder = usePathBuilder();
  var intl = useIntl();
  var realm = useRealm();
  var theme = useTheme();
  var _useNavigation = useNavigation(),
    isSignedIn = _useNavigation.isSignedIn;
  var isMobile = useMedia(["(max-width: ".concat(BREAKPOINTS.DESKTOP_SM - 1, "px)")], [true], false);
  var renderRealmSwitcher = function renderRealmSwitcher() {
    if (isSignedIn || !showRealmToggle) {
      return null;
    }
    return /*#__PURE__*/React.createElement(RealmWrapper, null, Object.values(getFilteredRealms(HEADER_REALM_KEYS)).map(function (realmValue) {
      return /*#__PURE__*/React.createElement(RealmNavItemWrapper, {
        selected: realm === realmValue
      }, /*#__PURE__*/React.createElement(MainNavItem, {
        as: Link,
        label: intl.formatMessage({
          id: "shared.layout.utilityBar.realm.".concat(realmValue)
        }),
        itemKey: realmValue,
        id: realmValue,
        to: "".concat(absoluteCiamDomain).concat(pathBuilder('/', true, {
          realm: realmValue
        }))
      }));
    }));
  };
  var mobileFooterItems = [];
  if (showContactUs) {
    mobileFooterItems.push( /*#__PURE__*/React.createElement(ContactUs, {
      key: "contact",
      absoluteCiamDomain: absoluteCiamDomain
    }));
  }
  if (showLangToggle) {
    mobileFooterItems.push( /*#__PURE__*/React.createElement(Lang, {
      key: "lang",
      onClick: onLanguageToggle
    }));
  }
  return /*#__PURE__*/React.createElement(SideNav$2, {
    activeKey: pathname,
    mobileFooterItems: mobileFooterItems,
    keepOpenOnSelect: false,
    mobileHeaderItems: [renderRealmSwitcher()]
  }, isMobile && isSignedIn && /*#__PURE__*/React.createElement(MainNavItem, {
    as: "button",
    icon: /*#__PURE__*/React.createElement(Icon, {
      fill: theme.colorPalette.neutralColors.light.shade_white,
      manulifeName: "signin"
    }),
    label: /*#__PURE__*/React.createElement(FormattedRichMessage, {
      id: "shared.layout.utilityBar.profile"
    }),
    itemKey: "profile",
    id: "profile"
  }, showManageId ? /*#__PURE__*/React.createElement(SubNavItem, {
    as: absoluteCiamDomain ? 'a' : Link,
    id: "manageid",
    label: /*#__PURE__*/React.createElement(FormattedRichMessage, {
      id: "shared.layout.utilityBar.manageId"
    }),
    to: "".concat(absoluteCiamDomain).concat(pathBuilder('/manageid')),
    itemKey: "manageid"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(SubNavItem, {
    as: "button",
    id: "signout",
    label: /*#__PURE__*/React.createElement(FormattedRichMessage, {
      id: "shared.layout.utilityBar.signOut"
    }),
    onClick: onLogout,
    itemKey: "signout"
  })));
};
process.env.NODE_ENV !== "production" ? SideNav.propTypes = {
  onLanguageToggle: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  absoluteCiamDomain: PropTypes.string,
  showLangToggle: PropTypes.bool,
  showContactUs: PropTypes.bool,
  showRealmToggle: PropTypes.bool,
  showManageId: PropTypes.bool
} : void 0;
SideNav.defaultProps = {
  absoluteCiamDomain: '',
  showLangToggle: true,
  showContactUs: true,
  showRealmToggle: true,
  showManageId: true
};
var SideNav$1 = SideNav;export{SideNav$1 as default};